
// export enum  policyType {

//     Statutaory = 1,
//     Internal = 2
// }

// export enum riskType {
//     High = 1,
//     Medium = 2,
//     Low = 3
// }

export var Enums = {
    policyType: [
        { "id": "1", "name": "Statutory" }, 
        { "id": "2", "name": "Internal" }
     ],
     RiskTypes:[
        { "id": "1", "name": "High" },
        { "id": "2", "name": "Medium" },
        { "id": "3", "name": "Low" }
     ],
     DateOptions:[
        { "id": "1", "name": "1 (Due date not on holidays / exchange holidays)" },
        { "id": "2", "name": "2 (Working days calculation)" },
        { "id": "3", "name": "3 (All days)" },
        { "id": "4", "name": "4 (Due date not on holidays)" }
     ],
     Departments:[
        { "id": "1", "name": "Finance" },
        { "id": "2", "name": "Account" },
        { "id": "3", "name": "HR" }
     ],
     TaskStatus:[
        { "id": "1", "name": "Pending" },
        { "id": "2", "name": "Completed" },
        { "id": "3", "name": "Delayed Completion" },
        { "id": "4", "name": "Partially Completed" },
        { "id": "5", "name": "NA" },
        { "id": "6", "name": "Done" },
        { "id": "7", "name": "Cancelled" }
     ],
     NCDLibraryFieldName : {
        seniority:"Seniority" ,
        modeOfIssue : "Mode of Issue",
        eligibleInvestors : "Eligible Investors",
        biddingType : "Bidding Type",
        allocationMethod : "Allocation Method",
        settlementmethod : "Settlement method",
        listing: "Listing (including name of Stock Exchange(s) where it will be listed and timeline for listing)",
        ObjectsOfIssue:"Objects of the issue",
        detailsOfUtilization : "Details of the utilization of the proceeds",
        stepUpAndDown : "Steps up/ step down coupon rate",
        security : "Security",
        redeemability : 'Redeemability',
        convertibility : 'Convertibility',
        typeOfIssue : "Type of Issue",
        interestPaymentrequest : "Interest Payment frequency"
     },
     NCDFieldType : {
         text : "Text",
         dropDown : "DropDownSelection",
         number : "Number",
         numberWithoutZero : "NumberWithoutZero"
     }
}


// export class Enum {
//     public PolicyType = policyType;
//     public RiskType = riskType;
// }